/* =============================================================================
   Farmoxa Premium — header navigation (hover/focus mega menus) + mobile drawer
   ============================================================================= */
(() => {
  'use strict';
  const header = document.querySelector('[data-fmx-header]');
  if (!header) return;

  /* ---------------------------------------------------------- desktop menus */
  const items = Array.from(header.querySelectorAll('[data-fmx-nav-item]'));
  let closeTimer = null;
  function open(item) {
    items.forEach((i) => { if (i !== item) close(i); });
    item.classList.add('is-open');
    item.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'true');
  }
  function close(item) {
    item.classList.remove('is-open');
    item.querySelector('[aria-expanded]')?.setAttribute('aria-expanded', 'false');
  }
  items.forEach((item) => {
    const trigger = item.querySelector('[data-fmx-nav-trigger]');
    if (!trigger) return;
    item.addEventListener('mouseenter', () => { clearTimeout(closeTimer); closeTimer = setTimeout(() => open(item), 90); });
    item.addEventListener('mouseleave', () => { clearTimeout(closeTimer); closeTimer = setTimeout(() => close(item), 160); });
    trigger.addEventListener('click', (e) => {
      // click toggles (touch devices / keyboard); if trigger is a link with a panel, first click opens
      e.preventDefault();
      item.classList.contains('is-open') ? close(item) : open(item);
    });
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) close(item); });
    item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(item); trigger.focus(); } });
  });
  document.addEventListener('click', (e) => { if (!header.contains(e.target)) items.forEach(close); });

  /* ----------------------------------- "Producten" panel: sector tabs (hover / focus / click / arrow keys) */
  header.querySelectorAll('[data-fmx-mm]').forEach((mm) => {
    const tabs = Array.from(mm.querySelectorAll('[data-fmx-mm-tab]'));
    const panels = Array.from(mm.querySelectorAll('[data-fmx-mm-panel]'));
    let hoverTimer = null;
    function activate(idx, focusTab) {
      tabs.forEach((t) => {
        const on = t.dataset.fmxMmTab === String(idx);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (on && focusTab) t.focus();
      });
      panels.forEach((p) => {
        const on = p.dataset.fmxMmPanel === String(idx);
        if (on && p.hidden) { p.hidden = false; p.classList.remove('is-active'); void p.offsetWidth; p.classList.add('is-active'); }
        else if (!on) { p.hidden = true; p.classList.remove('is-active'); }
      });
    }
    tabs.forEach((tab, i) => {
      tab.addEventListener('mouseenter', () => { clearTimeout(hoverTimer); hoverTimer = setTimeout(() => activate(tab.dataset.fmxMmTab, false), 70); });
      tab.addEventListener('focus', () => activate(tab.dataset.fmxMmTab, false));
      tab.addEventListener('click', () => activate(tab.dataset.fmxMmTab, true));
      tab.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          const next = (i + (e.key === 'ArrowDown' ? 1 : -1) + tabs.length) % tabs.length;
          activate(tabs[next].dataset.fmxMmTab, true);
        } else if (e.key === 'ArrowRight' || e.key === 'Enter') {
          const panel = panels.find((p) => p.dataset.fmxMmPanel === tab.dataset.fmxMmTab);
          const first = panel && panel.querySelector('a');
          if (first) { e.preventDefault(); first.focus(); }
        }
      });
    });
    mm.addEventListener('mouseleave', () => clearTimeout(hoverTimer));
  });

  /* ----------------------------------------------------------- mobile drawer */
  const drawer = document.querySelector('[data-fmx-drawer]');
  const openBtn = header.querySelector('[data-fmx-drawer-open]');
  if (drawer && openBtn) {
    let lastFocus = null;
    const panel = drawer.querySelector('.fmx-drawer__panel');
    function openDrawer() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      openBtn.setAttribute('aria-expanded', 'true');
      drawer.querySelector('.fmx-drawer__close')?.focus();
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      openBtn.setAttribute('aria-expanded', 'false');
      lastFocus?.focus?.();
    }
    openBtn.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-fmx-drawer-close]').forEach((b) => b.addEventListener('click', closeDrawer));
    drawer.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
      if (e.key === 'Tab' && panel) {
        const f = panel.querySelectorAll('a[href], button:not([disabled]), input, select, summary');
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    window.matchMedia('(min-width: 990px)').addEventListener?.('change', (m) => { if (m.matches) closeDrawer(); });
  }
})();
